export const FORM_FIELD_TYPES = Object.freeze([
  { value: 'STRING', label: 'String' },
  { value: 'INT', label: 'Int' },
  { value: 'EMAIL', label: 'Email' },
  { value: 'PASSWORD', label: 'Password' },
  { value: 'PHONE', label: 'Phone' },
  { value: 'RADIO', label: 'Radio' },
  { value: 'DROPDOWN', label: 'Dropdown' },
  { value: 'ENTITY', label: 'Entity' },
  { value: 'CHECKBOX', label: 'Checkbox' },
  { value: 'TEXTAREA', label: 'Textarea' },
  { value: 'BOOLEAN', label: 'Boolean' },
  { value: 'FLOAT', label: 'Float' },
  { value: 'DATE', label: 'Date' },
  { value: 'FILE', label: 'File' },
  { value: 'TIME', label: 'Time' },
  { value: 'CITY', label: 'City' },
  { value: 'PINCODE', label: 'Pincode' },
  { value: 'CUSTOM', label: 'Custom' },
]);

export const OPTION_FIELD_TYPES = Object.freeze(['DROPDOWN', 'CHECKBOX', 'RADIO']);

/** Virtual UI-only field type; persisted as DROPDOWN + is_status. */
export const UI_FIELD_TYPE_STATUS = 'STATUS';

export const STATUS_OPTIONS = Object.freeze([
  { value: '', label: 'Default' },
  { value: 'is_status', label: 'Status' },
  { value: 'is_sub_status', label: 'Sub Status' },
]);
